export const namespace = "common/";
export const SET_USER_ID = "SET_USER_ID";
export const SHOW_LOADING = "SHOW_LOADING";
export const HIDE_LOADING = "HIDE_LOADING";
export const SET_CONTINUE_DRAWING = "SET_CONTINUE_DRAWING";
export const SET_HAS_DRAWN = "SET_HAS_DRAWN";
export const SET_IS_TABLET = "SET_IS_TABLET";
export const SET_TO_FRONT_API_DISABLE = "SET_TO_FRONT_API_DISABLE";
export const SET_NEED_RELOAD = "SET_NEED_RELOAD";
export const SET_PAGE = "SET_PAGE";
